/**
 * Bundle cart behavior: remove parent + all linked children together.
 */
(function () {
  const BUNDLE_PROP = '_is_part_of_bundle';
  const BUNDLE_ID_PROP = '_bundle_id';

  function getProperty(item, key) {
    if (!item?.properties) return null;
    if (Array.isArray(item.properties)) {
      const match = item.properties.find((p) => p?.[0] === key || p?.first === key || p?.name === key);
      if (!match) return null;
      return match[1] ?? match.last ?? match.value ?? null;
    }
    return item.properties[key] ?? null;
  }

  function isBundleChild(item) {
    return String(getProperty(item, BUNDLE_PROP)) === 'true';
  }

  async function removeBundle(event) {
    const trigger = event.target.closest('[data-bundle-remove]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (trigger.getAttribute('aria-busy') === 'true') return;

    const bundleId = String(trigger.dataset.bundleId || '');
    const parentKey = trigger.dataset.lineKey;
    if (!bundleId || !parentKey) return;

    trigger.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      const updates = { [parentKey]: 0 };

      cart.items.forEach((item) => {
        if (!isBundleChild(item)) return;
        if (String(getProperty(item, BUNDLE_ID_PROP)) !== bundleId) return;
        updates[item.key] = 0;
      });

      const sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: [...sectionsToBundle].join(',')
        })
      });

      const cartContent = await response.json();

      if (!response.ok) {
        throw new Error(cartContent.description || cartContent.message || 'Unable to remove bundle');
      }

      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart: cartContent
          }
        })
      );
    } catch (error) {
      console.error('[cart-bundle]', error);
    } finally {
      trigger.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  document.addEventListener('click', removeBundle);
})();
